export default {
  meta: {
    public: false,
    auth: true,
    icon: "fa-rocket",
    expanded: false,
    label: "Utilities",
    permission: [config.permission.UTILITIES_INDEX]
  },
  children: [
    // {
    //   name: "change_plan",
    //   path: "/admin/change_plan",
    //   meta: {
    //     auth: true,
    //     label: "Change Plan",
    //     breadcrumb: [{ name: "Change Plan" }],
    //     permission: [config.permission.UTILITIES_CHANGED_PLAN_INDEX]
    //   },
    //   component: () => import("views/change_plan/index")
    // },
    {
      name: "update_po_pos",
      path: "/admin/update_po_pos",
      meta: {
        auth: true,
        label: "Update PO/POS",
        breadcrumb: [{ name: "Update PO/POS" }],
        permission: [config.permission.UTILITIES_APPROVED_PO_POS_INDEX]
      },
      component: () => import("views/update_po_pos/index")
    }
  ]
};
